export function returnIfString(value) {
  if (typeof value === "string") {
    return value.replaceAll("^", "\r\n");
  }
  return "";
}
